import PubSub from "underpub-js";

var HeroBackgroundImage = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-HeroBackgroundImage',
	};

	$.extend(true, this.options, options);

};

HeroBackgroundImage.prototype.init = function() {

	var self = this;

};

export default HeroBackgroundImage;
